import * as stylex from '@stylexjs/stylex';
import '../styles/tokens.stylex';
import { borderRadius, color, spacing } from '../styles/tokens.stylex';
import { PageSectionsTextBanner } from '@/tina/__generated__/types';
import { typography } from '../styles/typography';
import { PageSection } from './PageSection';
import { tinaField } from 'tinacms/dist/react';
import { calloutTypographyColors } from '../styles/themes';
import { Fragment } from 'react';
export interface TextBannerProps {
  data: PageSectionsTextBanner;
}
export function TextBanner({
  data,
  ...props
}: TextBannerProps) {
  const staggeredText = data.text.split(/ /g).map((word, i) => {
    return <Fragment key={`${i}-${word}`}>
        {i !== 0 && ' '}
        <span {...stylex.props([localStyles.wordAnimation, localStyles.wordAnimationDelay(i)])}>
          {word}
        </span>
      </Fragment>;
  });
  return <PageSection {...props}>
      <div {...stylex.props([calloutTypographyColors, localStyles.layout, localStyles.triggerParent])}>
        <p {...stylex.props([typography.display2, localStyles.text])} data-tina-field={tinaField(data, 'text')}>
          {staggeredText}
        </p>
      </div>
    </PageSection>;
}
const trigger = "x1kl34g5-B";
const reveal = "xqr83z7-B";
const hide = "xfxzuor-B";
const _temp = {
  kKxzle: "x8x7fgn " + "xnr68xs",
  "$$css": true
};
const localStyles = {
  layout: {
    k1xSpc: "x78zum5",
    kwnvtZ: "x1a02dak",
    kOIVth: "x1mhrlx8",
    kWkggS: "x5neqkr",
    kaIpWk: "xox9ipt",
    kmVPX3: "x15yfg05",
    $$css: true
  },
  triggerParent: {
    kKVMdj: "xgy0j4f",
    kyAemX: "x1nxgg22",
    kWV6AL: "x1u6ievf",
    kjjejL: "x12wghty",
    kKyw0Y: "xky64i9",
    kPiFwT: "xsigiph",
    $$css: true
  },
  text: {
    k9WMMc: "x2b8uid",
    kN2L0X: "x1w2vvpw",
    k7Eaqz: "x1gzrp8p",
    kUk6DE: "x98rzlu",
    kVQacm: "x7giv3",
    $$css: true
  },
  wordAnimation: {
    k1xSpc: "x1rg5ohu",
    k6sLGO: "x1q1rmc8",
    kWV6AL: "x1u6ievf",
    kKVMdj: "x1n3khcq xad4ve7 x1vop8qr",
    k44tkh: "x2mfxb",
    k3aq6I: "x1weeur4",
    $$css: true
  },
  wordAnimationDelay: (order: number) => [_temp, {
    "--x-j3h0cz": (val => typeof val === "number" ? val + "ms" : val != null ? val : undefined)(`${1.5 + order / 10}s`),
    "--x-9r3jk3": (val => typeof val === "number" ? val + "ms" : val != null ? val : undefined)(`${order / 10}s`)
  }]
};